module.exports = __webpack_public_path__ + "img/image_online01@2x.b782c281.png";